'use strict';
import gsap from "gsap";
import {Draggable} from "gsap/Draggable";
import { CardTypes, ViewMode } from '../../common';
import { cardsData, isMobile, projectMode, settingsData, threeJsVariables} from "../../settings";
import {
    openOptionsCard, removeOptionsCardGallery,
    resizeOptionsCardGallery,
    setWidthOfCardDependingOnMenu,
} from './optionsCards';
import {changeCanvasSizeWhenCardIsOpened} from "../controls/orbitControls";
import {setSizesToFloorSlider} from "../floorSlider/floorSlider";
import {selectionBoxesSetStatusColor} from "../threejs/raycast";
import { getUrlParam, userPrevent } from '../../functions';
import {findSelectionAndCrmData, rotation_to_flat} from "../../functions";
import {conferenceStatistic} from "../analytics/conferenceStatistic";
import {showStatisticPopUp} from "../analytics/statistic";
import {setActiveClassHandler} from "./unitCards/unitCardFunctions";
import {UnitCardClass} from "./unitCards/UnitCardClass";
import { canvasResize } from '../../app';
import { Amenities } from '../amenities/Amenities';

/**
 *  Web animations
 */
export const createUnitCardAnimation = (object) => {
    const desktopMode = settingsData.isDesktopMode;
    const cardBox = UnitCardClass.findCard(object.engineId)?.html;

    if (desktopMode) {
        createUnitCardDesktopAnimation(cardBox);
        return;
    }

    const directionHtml = document.documentElement.getAttribute('dir');
    const menuPosition = document.querySelector('.aside__container').getAttribute('data-menu-position');

    let direction = (menuPosition === 'right') ? 'left' : 'right';
    const navBar = document.querySelector('.right-nav-bar');

    const winY = threeJsVariables.mouse.winY;
    const winX = threeJsVariables.mouse.winX;

    const offsetWidth = directionHtml === 'rtl' ? 32 : 37;
    let position = offsetWidth;

    if (settingsData.buildingDestroyed) {
        position = navBar.clientWidth + offsetWidth * 2;
    }

    if (UnitCardClass.cards.length > 1) {
        const unitCardStyle = UnitCardClass.findCard().html.style;
        const positionPrevCard = unitCardStyle.right ? 'left' : 'right';
        // console.log(unitCard.html.style.left, unitCard.html.style.right);
        // direction = (menuPosition === 'right') ? 'right' : 'left';
        direction = positionPrevCard;
        const searchWidth = document.querySelector('.search__container-main').getBoundingClientRect().width;
        const menuWidth = document.querySelector('.aside__container').getBoundingClientRect().width;

        if (directionHtml === 'rtl') {
            position = direction === 'left' ? offsetWidth : searchWidth + menuWidth + 30;
        } else {
            position = direction === 'left' ? searchWidth + menuWidth + 30 : offsetWidth;
        }

    }


    const tl = gsap;
    tl.from(cardBox, {
        top: winY,
        [direction]: winX,
        scale: 0
    })
    tl.to(cardBox, {
        duration: 1.8,
        [direction]: UnitCardClass.findCard(false, 'non-active')?.html ? position + 20 : position,
        ease: "expo.out",
        scale: window.innerWidth <= 1600 ? 0.95 : 1,
        top: 110,
        onStart: () => {
            settingsData.bombBlock = true;
        },
        onComplete: () => {
            settingsData.bombBlock = false;
        }
    });
    fadeInUnitCardAnimation(0.6, .4, cardBox);
}

export const closeUnitCardAnimation = (currentCard, closeAll) => {
    fadeOutUnitCardAnimation(.2, 0, currentCard);
    const tl = gsap.timeline({
        onComplete: () => {
            currentCard.remove();
            const unitCard = UnitCardClass.findCard()?.html;
            isMobile && canvasResize();
            if (unitCard && !closeAll) {
                const keyPlanButton = unitCard.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
                const engineId = unitCard.getAttribute('data-engineid');
                const {selectedMesh} = findSelectionAndCrmData(engineId);
                cardsData.cardMode.isDoubleCard = true;
                selectedMesh.userData.isClicked = true;

                if (settingsData.buildingDestroyed) {
                    keyPlanButton.click();
                } else {
                    rotation_to_flat(selectedMesh);
                    selectionBoxesSetStatusColor(selectedMesh, 'click');
                }

                setTimeout(() => {
                    cardsData.cardMode.isDoubleCard = false;
                }, 300);

                unitCard.classList.remove('non-active');

                if (cardsData.multiplyCards) {
                    unitCard.classList.add('active');
                } else {
                    // unitCard.classList.remove('active');
                }
            }
        }
    });
    tl.to(currentCard, {
        duration: .2,
        delay: .2,
        scaleX: 1,
        scaleY: 0.01,
        ease: "expo.out"
    })
        .to(currentCard, {
            duration: .1,
            scaleX: 0,
            scaleY: 0,
        });
}

export const dragUnitCard = () => {
    gsap.registerPlugin(Draggable);
    const cardBox = document.querySelectorAll(`.${CardTypes.Unit}-card`);

    if (!cardBox) return;

    let menuWidth = document.querySelector('.aside__container').offsetWidth;
    let buttonsHeight = document.querySelector('.bottom__nav-bar').getBoundingClientRect().height;

    const rtl = document.documentElement.getAttribute('dir') === 'rtl';

    const desktopModeBounce = {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height:window.innerHeight - (buttonsHeight + 80)
    };

    const webModeBounce = {
        top: 0,
        left: rtl ? 0 : menuWidth,
        width: window.innerWidth - menuWidth,
        height:window.innerHeight
    };

    Draggable.create([...cardBox], {
            type: "x,y",
            edgeResistance: 1,
            bounds: settingsData.isDesktopMode ? desktopModeBounce : webModeBounce,
            inertia: true,
            zIndexBoost: false,
            onDragStart: (cardBox) => {
                cardsData.multiplyCards && setActiveClassHandler(cardBox);
            },
        }
    );
}

export const openOptionsCardAnimation = () => {
    const tl = gsap;
    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
    const exploreBtn = document.querySelector(`.${CardTypes.Unit}-card__button-floor-plan`);
    const param = getUrlParam('prop');

    let winY, winX, height, width;

    if (param || !exploreBtn) {
        winY = 1;
        winX = 1;
        height = 1;
        width = 1;
    } else {
        winY = cardsData.cardMode.isAmenities ? threeJsVariables.mouse.winY : exploreBtn.getBoundingClientRect().top;
        winX = cardsData.cardMode.isAmenities ? threeJsVariables.mouse.winX : exploreBtn.getBoundingClientRect().left;
        height = cardsData.cardMode.isAmenities ? 0 : exploreBtn.getBoundingClientRect().height;
        width = cardsData.cardMode.isAmenities ? 0 : exploreBtn.getBoundingClientRect().width;
    }


    tl.fromTo(optionsCard, {
        top: winY,
        left: winX,
        height: height,
        width: width,
    }, {
        duration: param ? 1 : .5,
        ease: "expo.out",
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,

        onUpdate: () => {
            settingsData.bombBlock = true;
        },

        onComplete: () => {
            settingsData.bombBlock = false;
            !isMobile && setWidthOfCardDependingOnMenu(optionsCard);
        }
    });

    fadeInOptionsCardAnimationDesktop(0.5, .6);
}

export const closeOptionsCardAnimation = () => {
    const optionCard = document.querySelector(`.${CardTypes.Options}-card`) || document.querySelector(`.${CardTypes.Options}-card .${CardTypes.Amenities}-card`);
    const unitCard = UnitCardClass.findCard()?.html;
    const tl = gsap;

    tl.to(unitCard, {
        duration: .5,
        onComplete: () => {
            optionCard.remove();
            removeOptionsCardGallery();
        }

    })
}

export const fadeInUnitCardAnimation = (duration, delay = 0, cardBox) => {
    const card = CardTypes.Unit;

    const cardBoxWrapper = cardBox.querySelector(`.${card}-card__wrapper`);
    const previewBox = cardBox.querySelector(`.${card}-card__preview-block`);
    const tl = gsap;
    tl.fromTo([cardBoxWrapper, previewBox], {
        autoAlpha: 0,
        onStart:()=>{
            userPrevent(true);
        },
        onComplete:()=>{
            userPrevent(false);
        }
    }, {
        autoAlpha: 1,
        duration: duration,
        delay: delay,
    });
}

export const fadeOutUnitCardAnimation = (duration, delay = 0, currentCard = UnitCardClass.findCard(false, 'active').html) => {
    const card = CardTypes.Unit;
    const cardBoxWrapper = currentCard.querySelector(`.${card}-card__wrapper`);
    const previewBox = currentCard.querySelector(`.${card}-card__preview-block`);
    const tl = gsap;

    tl.fromTo([cardBoxWrapper, previewBox], {autoAlpha: 1}, {
        autoAlpha: 0,
        duration: duration,
        delay: delay,
    });
}

export const fadeInOptionsCardAnimationDesktop = (duration, delay = 0) => {
    const cardBox = document.querySelector(`.${CardTypes.Options}-card`);
    const tl = gsap;
    tl.fromTo([cardBox.childNodes], {autoAlpha: 0}, {autoAlpha: 1, duration: duration, delay: delay});
}

/**
 *  Mobile animations
 */

// unit card
export const openAndCloseMobileUnitCard = (action) => {
    const cardBox = UnitCardClass.findCard()?.html;

    if (!cardBox) return;

    const sliderWidth = document.querySelector('.right-nav-bar').getBoundingClientRect().width;
    const isDestroyed = settingsData.buildingDestroyed;
    const direction = {}

    switch (action) {
        case 'open':
            direction.from = {
                bottom: '-100%',
                left: '50%',
                right: 'initial',
            };
            direction.to = {
                bottom: '0',
                left: '50%',
                right: 'initial',
            };
            break;
        case 'close':
            direction.from = {
                bottom: '0',
                left: '50%',
                right: 'initial',
            };
            direction.to = {
                bottom: '-100%',
                left: '50%',
                right: 'initial',
                complete: true
            };
            break;
        case 'ltr-open':
            direction.from = {
                bottom: '0',
                left: 'initial',
                right: '-100%',
            };
            direction.to = {
                bottom: '0',
                left: 'initial',
                right: isDestroyed ? `${sliderWidth}` : `0`,
            };
            break;
        case 'rtl-open':
            direction.from = {
                bottom: '0',
                left: '-100%',
                right: 'initial',
            };
            direction.to = {
                bottom: '0',
                left: isDestroyed ? `${sliderWidth}` : `0`,
                right: 'initial',
            };
            break;
        case 'ltr-close':
            direction.from = {
                bottom: '0',
                left: 'initial',
                right: isDestroyed ? `${sliderWidth}` : `0`,
            };
            direction.to = {
                bottom: '0',
                left: 'initial',
                right: '-100%',
                complete: true
            };
            break;
        case 'rtl-close':
            direction.from = {
                bottom: '0',
                left: isDestroyed ? `${sliderWidth}` : `0`,
                right: `initial`,
            };
            direction.to = {
                bottom: '0',
                left: '-100%',
                right: 'initial',
                complete: true
            };
            break;
    }

    const tl = gsap;
    tl.fromTo(cardBox, {
        bottom: direction.from.bottom,
        left: direction.from.left,
        right: direction.from.right,
    }, {
        bottom: direction.to.bottom,
        left: direction.to.left,
        right: direction.to.right,
        onStart:()=>{
            userPrevent(true);
        },
        onComplete: () => {
            userPrevent(false);
            if (direction.to.complete) {
                UnitCardClass.closeMobileCard();
                if (settingsData.activeViewMode === ViewMode.Cylinder){
                    !settingsData.activeModeSwitching && Amenities.show(0);
                }
                canvasResize();
            } else {
                canvasResize();
            }
            // setSizesToFloorSlider();
        },
    });

    fadeInUnitCardAnimation(0.6, .4, cardBox);
}

// options card
export const openAndCloseMobileOptionsCard = (e, object = settingsData.lastClickedFlat.userData.crm_data, settings = config) => {
    const unitCard = UnitCardClass.findCard().html;
    const unitCardPreview = unitCard.querySelector(`.${CardTypes.Unit}-card__preview-block`);
    const unitCardWrapper = unitCard.querySelector(`.${CardTypes.Unit}-card__wrapper`);

    // if (object.status !== 'Available') return;

    const tl = gsap.timeline();
    tl.to([unitCardPreview, unitCardWrapper], {
        duration: .2,
        opacity: 0,
    })
    tl.to(unitCard, {
        height: '100%',
        width: settingsData.isLandscape ? '100%' : '92vw',
        duration: .2,
        onUpdate: () => {
            unitCard.style.backgroundColor = 'var(--screenBg)';
            unitCard.style.width = '100%'
        },
        onComplete: () => {
            setTimeout(() =>  unitCard.style.backgroundColor = 'var(--menuBg)', 500 );

            if (settingsData.isLandscape) {
                openOptionsCard(object, settings);
                unitCardWrapper.removeAttribute('style');
                unitCardPreview.removeAttribute('style');
                unitCard.style.width = '276px';
            }
        }
    })
    !settingsData.isLandscape && tl.to(unitCard, {
        width: '100%',
        duration: .2,
        onComplete: () => {
            openOptionsCard(object, settings);
            unitCardWrapper.removeAttribute('style');
            unitCardPreview.removeAttribute('style');
            unitCard.removeAttribute('style');
        },
    })

    // fadeInUnitCardAnimation(0.6, .4);
}

export const fadeInOptionsCardAnimation = (duration, delay = 0) => {
    const closeBtn = document.querySelector(`.${CardTypes.Options}-card__close-btn`);
    const plansBox = document.querySelector(`.${CardTypes.Options}-card__plans-box`);
    const dataBox = document.querySelector(`.${CardTypes.Options}-card__data`);
    const optionsBtnBox = document.querySelector(`.${CardTypes.Options}-card__options-buttons`);

    const tl = gsap;
    tl.fromTo([closeBtn, plansBox, dataBox, optionsBtnBox], {autoAlpha: 0}, {
        autoAlpha: 1,
        duration: duration,
        delay: delay
    });
}

export const fixedElementsPositionDurScrolling = () => {
    const scrollPlug = document.querySelector(`.${CardTypes.Options}-card__scroll-plug`);
    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
    const header = document.querySelector(`.${CardTypes.Options}-card__header`);
    const optionsParameters = scrollPlug.getBoundingClientRect();
    const previewBlockParameters = document.querySelector(`.${CardTypes.Options}-card__plans-box`).getBoundingClientRect();
    const currentDirection = document.documentElement.getAttribute('dir');
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const padding = currentDirection === 'rtl' ? '0 16px 3px 20px' : '0 20px 3px 16px';

    optionsCard.addEventListener('scroll', function scroll(e) {
        e.preventDefault();

        if (optionsCard.scrollTop > optionsParameters.height) {
            scrollPlug.style.backgroundColor = '#151515';
        } else {
            scrollPlug.removeAttribute('style')
        }

        if (optionsCard.scrollTop > previewBlockParameters.height - optionsParameters.height) {

            header.style.position = 'fixed';
            header.style.backgroundColor = '#151515';
            header.style.top = '57px';
            header.style.width = '100%';
            header.style.zIndex = '6';
            header.style.left = '0';
            header.style.padding = !isSafari ? padding : '0 16px 3px 16px';
            document.querySelector(`.${CardTypes.Options}-card__info-points`).style.marginTop = '95px';
        } else {
            header.removeAttribute('style');
            document.querySelector(`.${CardTypes.Options}-card__info-points`).removeAttribute('style');
        }
    });
}

/**
 * Desktop animations
 */

export const createUnitCardDesktopAnimation = (cardBox) => {

    let direction = 'right';
    const search = document.querySelector(`.search__container-main`);
    const searchWidth = search.getBoundingClientRect().width;

    const winY = threeJsVariables.mouse.winY;
    const winX = threeJsVariables.mouse.winX;

    let position = searchWidth + 80;

    if (UnitCardClass.cards.length > 1) {
        const unitCardStyle = UnitCardClass.findCard().html.style;
        const positionPrevCard = unitCardStyle.right ? 'left' : 'right';
        direction = positionPrevCard;
        const searchWidth = document.querySelector('.search__container-main').getBoundingClientRect().width;

        position = direction === 'left' ? '200px' : searchWidth + 80;
    }

    const tl = gsap;
    tl.from(cardBox, {
        top: winY,
        [direction]: winX,
        scale: 0
    })
    tl.to(cardBox, {
        duration: 1.8,
        [direction]: position,
        top: 200,
        ease: "expo.out",
        scale: 1.3,

        onUpdate: () => {
            settingsData.bombBlock = true;
        },

        onComplete: () => {
            settingsData.bombBlock = false;
        }
    });
    fadeInUnitCardAnimation(0.6, .4, cardBox);
}

export const moveOptionsCardTimeout = (object) => {
    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
    const optionsCardData = document.querySelector(`.${CardTypes.Options}-card__data`);
    const menu = document.querySelector('.aside__container');
    const rtl = document.documentElement.getAttribute('dir') === 'rlt';

    if (isMobile || !optionsCard) return;

    const tl = gsap;

    tl.to(optionsCard, {
        gridTemplateColumns: !settingsData.isDesktopMode && !rtl ? `130px 1fr` : `1fr 130px`,
        duration: 0.5,
        delay: 6,
        onComplete: () => {
            optionsCardData.classList.add('close-data');
            const {isConferenceHost} = settingsData;
            const isActiveGoogleStatistic = config.features.googleAnalytics?.active;

            if (document.querySelector(`.${CardTypes.Options}-card`)){
                isConferenceHost && setTimeout(() => conferenceStatistic(object), 500);
                isActiveGoogleStatistic && !isConferenceHost && setTimeout(() => showStatisticPopUp(object), 500);
            }
        },
        onUpdate: () => resizeOptionsCardGallery(),
    });

    if (!settingsData.isDesktopMode) {
        tl.to(menu, {
            zIndex: 8,
        })
    }
}

export const draggableOptionsCardBlock = (e, action) => {
    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
    const optionsCardData = document.querySelector(`.${CardTypes.Options}-card__data`);

    const stopAnimation = checkClick(e);
    if (stopAnimation) return;
    const isClose = optionsCardData.classList.contains('close-data');

    const isDesktop = settingsData.isDesktopMode;

    if (!action) {
        action = isClose ? 'open' : 'close';
    }

    let gridLayout;

    switch (action) {
        case ('open'):
            gridLayout = isDesktop ? `1fr 420px` : `420px 1fr`;
            break;
        case ('close'):
            gridLayout = isDesktop ? `1fr 130px` : `130px 1fr`;
            break;
    }

    if (isMobile || !optionsCard) return;

    const tl = gsap;

    tl.to(optionsCard, {
        gridTemplateColumns: gridLayout,
        duration: 0.5,
        onStart: () => {
            action === "open" ? optionsCardData.classList.remove('close-data') : optionsCardData.classList.add('close-data');
        },
        onUpdate: () => resizeOptionsCardGallery()
    })
}

const checkClick = (e) => {
    const applyNowBtn = e.target === document.querySelector(`.${CardTypes.Options}-card__apply-now-btn`);
    const buyNow = e.target === document.querySelector(`.${CardTypes.Options}-card__buy-now_conf`);
    const similarAppChildEl = e.target.closest(`.similar-apt__container`);
    const favorite = e.target.closest(`.${CardTypes.Options}-card__favorite`);
    const switchers = e.target.closest('.similar-switcher-block');

    return !!(favorite || switchers || similarAppChildEl || applyNowBtn || buyNow);
}

/**
 * COMPARE CARDS ANIMATION
 */

export const rollUpAndExpandCompareCards = (e) => {
    const clickedCard = e.target.closest('.compare-block__card');

    const compareCardList = document.querySelectorAll('.compare-block__card');

    compareCardList.forEach(elem => {
        const elemId = elem.getAttribute('data-engineid');

        if (elemId && elemId !== clickedCard?.getAttribute('data-engineid')) {
            elem.classList.toggle('minimized');
        }

        clickedCard?.classList.remove('minimized');
    })

}

